/* eslint-disable import/prefer-default-export */
export function formatNumbers(num) {
  return Number(num).toLocaleString()
}
/* eslint-enable import/prefer-default-export */